export default "__VITE_ASSET__DMWl4FvO__"